import { LitElement, html, css } from 'lit';
import { validationHandlerClear, validationHandler } from '../../utilities/formsUtilities';
import { close } from '../../utilities/icons';
import { accessibility, formStyles } from '../../utilities/styles';
export class AllInImageUploader extends LitElement {
    static properties = {
        label: { type: String },
        labelalt: { type: String },
        tablelabelalt: { type: String },
        required: { type: Boolean },
        inputname: { type: String },
        altinput: { type: String },
        id: { type: String },
        src: { type: String, reflect: true },
        altrequired: { type: String },
        error_message: { type: String },
        description: { type: String },
        removeStyle: { type: String },
        hideDelete: { type: Boolean, attribute: 'hide-delete' }
    };
    static get formAssociated() {
        return true;
    }
    get img() {
        return this.renderRoot.querySelector('img');
    }
    get input() {
        return this.renderRoot.querySelector('input');
    }
    get hiddenInput() {
        return this.renderRoot.querySelector(`input[type='hidden']`);
    }
    constructor() {
        super();
        this._internals = this.attachInternals();
        if (!this.src) {
            this.src = '';
        }
        if (!this.id) {
            this.id = this.inputname;
        }
        if (!this.removeStyle) {
            this.removeStyle = 'x';
        }
    }
    createRenderRoot() {
        return this;
    }
    render() {
        if (!this.inputname || !this.label) {
            return '';
        }
        let description = '';
        if (this.description) {
            description = html `<p class="small">${this.description}</p>`;
        }
        let input = '';
        let altinput = '';
        if (this.altinput) {
            altinput = html `<input type='hidden' name='alt_${this.inputname}' value='${this.altinput}' /> <input type='hidden' name='delete_${this.inputname}' value='0' />`;
        }
        if (this.required) {
            input = html `<input @change=${this._onChange} aria-required='true' type='file' data-label='${this.labelalt}' data-table_label='${this.tablelabelalt}' name='${this.inputname}' id='${this.id}' accept='image/png, image/jpeg, image/webp' data-error_message=${this.error_message} style="${this.src ? 'display:none;' : ''}"/>${altinput}`;
        }
        else {
            input = html `<input @change=${this._onChange} type='file' data-label='${this.labelalt}' data-table_label='${this.tablelabelalt}' name='${this.inputname}' id='${this.id}' accept='image/png, image/jpeg, image/webp' data-error_message=${this.error_message} style="${this.src ? 'display:none;' : ''}"/>${altinput}`;
        }
        if (this.removeStyle == 'words') {
            let filename = this.src ? this.src.split('%2F').pop() : '';
            return html `\n                <label for=${this.inputname} class="screen-reader-text">${this.label}</label>\n                <div class="image-uploader">\n                    <img src='${this.src ? this.src : ''}' data-has_src="${this.src ? "true" : "false"}" title='click to change image' alt='file preview'  />\n                    ${filename ? html `<a href="${this.src ? this.src : ''}" download="${filename}" class="words">${filename}</a>` : ''}\n                    <button @click=${this._clearForm} aria-label='click to change image' class="words">Newid ffeil</button>\n                    ${!this.hideDelete ? html `\n                        <button @click=${this._clearForm} aria-label='click to change image' class="words">\n                            Dileu delwedd\n                        </button>\n                    ` : ''} \n                </div>\n                ${description}\n                ${input}\n                    `;
        }
        return html `\n        \n        <label for=${this.inputname}>${this.label}</label>  \n        <div class="image-uploader">\n            <img src='${this.src ? this.src : ''}' data-has_src="${this.src ? "true" : "false"}" title='click to change image' alt='file preview'  />\n            <button @click=${this._clearForm} aria-label='click to change image'><span class="screen-reader-text">Tynnu Delwedd</span><span aria-hidden="true">${close}</span></button>\n        </div>\n        ${description}\n        ${input}\n        \n        `;
    }
    _onChange(e) {
        validationHandlerClear(e.target);
        let _fileSize = e.target.files[0]?.size ? e.target.files[0].size : 0;
        let fileSize = ((_fileSize / 1024) / 1024).toFixed(2);
        if (fileSize > 10) {
            validationHandler(e.target, `Rhaid i faint y ffeil fod yn 10MB neu lai`);
            this.input.value = "";
            e.preventDefault();
            return;
        }
        let reader = new FileReader();
        reader.addEventListener('load', () => {
            let result = reader.result?.split(',');
            if (result.length > 1 && result[1].length) {
                this.img.src = reader.result;
                this.img.dataset.has_src = "true";
                let multiloader = this.closest('allin-multiloader');
                if (multiloader) {
                    multiloader._handleHideReveal();
                }
                this.input.style.display = 'none';
                // Save file in parent form
                const pagedForm = this.closest('allin-paged-form');
                if (pagedForm) {
                    pagedForm._filesMap.set(this.inputname, {
                        file: e.target.files[0],
                        dataURL: reader.result,
                        alt: this.altrequired ? (document.querySelector(`#${this.altrequired}`)?.value || '') : ''
                    });
                }
                if (this.altrequired) {
                    // let altInput = document.querySelector(`#${this.altrequired}`);
                    // let altLabel = document.querySelector(`label[for='${this.altrequired}']`);
                    let root = this.getRootNode();
                    let altInput = root.querySelector(`#${this.altrequired}`);
                    let altLabel = root.querySelector(`label[for='${this.altrequired}']`);
                    if (altInput) {
                        altInput.setAttribute('aria-required', 'true');
                        // newly added for further validation strength - That makes the <input> element participate in the browser’s built-in form validation, not just ARIA semantics.
                        altInput.required = true;
                        if (!altLabel.querySelector('span')) {
                            let span = document.createElement('span');
                            span.textContent = '*';
                            altLabel.appendChild(span);
                            // validationHandler(altInput, msg(str`Provide ALT field 1 from Label`));
                            // Initial check
                            if (!altInput.value.trim()) {
                                validationHandler(altInput, `Ychwanegwch destun amgen`);
                            }
                            // Update validation as the user types
                            altInput.addEventListener('input', function () {
                                if (!altInput.value.trim()) {
                                    validationHandlerClear(altInput);
                                    validationHandler(altInput, `Ychwanegwch destun amgen`);
                                }
                                else {
                                    validationHandlerClear(altInput);
                                }
                            });
                        }
                    }
                }
            }
            else {
                this.img.src = '';
                this.img.dataset.has_src = "false";
                this.input.style.display = 'inline';
                if (this.altrequired) {
                    let altInput = document.querySelector(`#${this.altrequired}`);
                    if (altInput) {
                        altInput.removeAttribute('aria-required');
                    }
                }
            }
        }, false);
        if (e.target.files[0]) {
            reader.readAsDataURL(e.target.files[0]);
        }
        this._internals.setFormValue(e.target.value);
        this.img.addEventListener('click', () => {
            this.input.click();
        });
    }
    triggerExternalFileLoaded() {
        this.img.dataset.has_src = "true";
        let multiloader = this.closest('allin-multiloader');
        if (multiloader) {
            multiloader._handleHideReveal();
        }
        this.input.style.display = 'none';
        if (this.altrequired) {
            // let altInput = document.querySelector(`#${this.altrequired}`);
            // let altLabel = document.querySelector(`label[for='${this.altrequired}']`);
            let root = this.getRootNode();
            let altInput = root.querySelector(`#${this.altrequired}`);
            let altLabel = root.querySelector(`label[for='${this.altrequired}']`);
            if (altInput) {
                altInput.setAttribute('aria-required', 'true');
                // newly added for further validation strength - That makes the <input> element participate in the browser’s built-in form validation, not just ARIA semantics.
                altInput.required = true;
                if (!altLabel.querySelector('span')) {
                    let span = document.createElement('span');
                    span.textContent = '*';
                    altLabel.appendChild(span);
                }
            }
        }
    }
    _clearForm(e) {
        e.preventDefault();
        const deleteInput = this.querySelector(`input[name="delete_${this.inputname}"]`);
        if (deleteInput) {
            deleteInput.value = "1";
        }
        this.img.src = '';
        this.img.dataset.has_src = "false";
        this.input.style.display = 'inline';
        this.input.value = '';
        console.log(this.hiddenInput);
        if (this.hiddenInput) {
            this.hiddenInput.value = '';
        }
        this._internals.setFormValue('');
        if (this.altrequired) {
            // let altInput = document.querySelector(`#${this.altrequired}`);
            // let altLabel = document.querySelector(`label[for='${this.altrequired}']`);
            let root = this.getRootNode();
            let altInput = root.querySelector(`#${this.altrequired}`);
            let altLabel = root.querySelector(`label[for='${this.altrequired}']`);
            if (altInput) {
                // new additions for strengthening ALT validation
                altInput.required = false;
                altInput.removeAttribute('aria-required');
                altLabel.querySelector('span')?.remove();
            }
        }
    }
    checkValidity() {
        return this._internals.checkValidity();
    }
    reportValidity() {
        return this._internals.reportValidity();
    }
    get validity() {
        return this._internals.validity;
    }
    get validationMessage() {
        return this._internals.validationMessage;
        if (!altInput) {
            validationHandler(e.target, `Darparu maes amgen 3`);
        }
    }
    static styles = [
        accessibility,
        formStyles,
        css `
            img[src=''],img[data-has_src='false']{
                display:none;
            }
             
            
        `
    ];
}
